export interface SavedImport {
    id: string;
    fingerprint: string;
    rowFingerprints: string[];
    keys: string[];
    succeeded: boolean[];
}

export interface StoredImports {
    jobs: SavedImport[];
}

export function importStorageKey(userId: string): string {
    return `ecparcel.order-import.v1.${userId}`;
}

export function prepareImportState(
    state: StoredImports,
    fingerprint: string,
    rowFingerprints: string[],
    createId: () => string
): { state: StoredImports; jobId: string; keys: string[]; succeeded: boolean[] } {
    let job = [...state.jobs].reverse().find((candidate) => candidate.fingerprint === fingerprint && candidate.succeeded.some((value) => !value));
    const unfinishedJob = [...state.jobs].reverse().find((candidate) => candidate.succeeded.some((value) => !value));
    if (!job && unfinishedJob) {
        throw new Error('An earlier import still has unfinished orders. Reload its original CSV and retry those rows before starting another import.');
    }
    if (!job) {
        job = {
            id: createId(), fingerprint, rowFingerprints,
            keys: rowFingerprints.map(() => createId()),
            succeeded: rowFingerprints.map(() => false)
        };
        state.jobs.push(job);
    }
    return { state, jobId: job.id, keys: [...job.keys], succeeded: [...job.succeeded] };
}

export function markImportRowSucceeded(state: StoredImports, jobId: string, rowIndex: number): StoredImports {
    const job = state.jobs.find((candidate) => candidate.id === jobId);
    if (!job) return state;
    job.succeeded[rowIndex] = true;
    if (job.succeeded.every(Boolean)) state.jobs = state.jobs.filter((candidate) => candidate.id !== jobId);
    return state;
}
